import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "modules/core/pages/Error404";

import { componentLazyImport } from "modules/core/utils/helpers";

import { reportsPrivateRoutesConstants as routesConstants } from "./routesConstants";

// Pages
const ReportsPage = lazy(() =>
  componentLazyImport(() => import("../../pages/Reports"))
);

const ReportsPrivateRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={routesConstants.root.path}>
        <ReportsPage />
      </Route>

      <Route>
        <Error404 />
      </Route>
    </Switch>
  );
};

export default ReportsPrivateRoutes;
